<template>
    <div class="container">
        <!--    <div style="width: 100%;text-align: center;">-->
        <!--      <img src="@/assets/top-logo.png" style="width:55%;margin: 30px 0 40px"/>-->
        <!--    </div>-->
        <div style="width: 100%;display:flex;justify-content: center;">
            <el-carousel height="400px"
                         style="width: 1340px;margin: 40px 50px 1px 50px;border: 2px solid rgb(144, 188, 156);box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.2);border-radius: 30px;">
                <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                    <div style="background: #dfdfdf; height: 100%;">
                        <img
                                @click="jumpTo(item.href)"
                                style="
              height: 100%;
              width: 100%;
              cursor: pointer;
              object-fit: cover;
              border-radius: 20px;"
              :src="item.img"
              alt=""
          />
          <img src="@/assets/go.png" @click="jumpTo(item.href)" class="go"/>
        </div>
      </el-carousel-item>
    </el-carousel>
    </div>
    <div class="streaming-recommend">
      <div style="max-width: 1340px;min-width: 1000px;margin: 0 50px;">
<!--        <div style="height: 66vh;">-->
          <div class="recommend-title">
            <div style="width: 50%;font-size: 20px;font-weight: bold;">直播推荐</div>
            <div class="more" @click="jumpToMore()">查看更多+</div>
          </div>
          <div class="scrollbar-flex-content" v-if="!$store.getters.token">
            <div
                @click="goStreaming(item.id)"
                v-for="item in recommendList"
                :key="item.id"
                class="streaming-wrap"
            >
              <div class="stream-img">
                <img :src="item.img_pc" alt="" />
                <div class="img-tag">
                  {{
                    item.status == 0
                        ? "未开始"
                        : item.status == 1
                            ? "直播中"
                            : "已结束"
                  }}
                </div>
              </div>
              <div style="display:flex;flex-flow: column;color: rgb(12, 90, 31);">
                <div style="display:flex;flex-flow: row;">
                  <div>
                    <img style="width: 60px;height: 60px;border-radius: 50%;border: 2px solid rgb(167, 202, 172);" :src="item.anchor.user.avatar" alt="" />
                  </div>
                  <div style="margin-top: 10px;margin-left: 15px;">
                    <div style="font-size: 16px;">{{item.anchor.user.name}}</div>
                    <div v-html="filterAnchor(item.anchor.detail)" class="anchor"></div>
                  </div>
                </div>
                <div style="font-size: 20px;font-weight: bolder;text-align: left;color: rgb(12, 90, 31);height: auto;width: 90%;word-break:break-all;">
                  {{item.name}}
                </div>
                <div class="streaming-time"><img src="@/assets/time.png" alt=""/>直播时间：{{ item.start_at }}</div>
              </div>
            </div>
          </div>
          <div class="scrollbar-flex-content" v-else>
          <div
              @click="$router.push('/streaming-page/' + item.id)"
              v-for="item in recommendList"
              :key="item.id"
              class="streaming-wrap"
          >
            <div class="stream-img">
              <img :src="item.img_pc" alt="" />
              <div class="img-tag">
                {{
                  item.status == 0
                      ? "未开始"
                      : item.status == 1
                          ? "直播中"
                          : "已结束"
                }}
              </div>
            </div>
            <div style="display:flex;flex-flow: column;color: rgb(12, 90, 31);">
              <div style="display:flex;flex-flow: row;">
                <div>
                  <img style="width: 60px;height: 60px;border-radius: 50%;border: 2px solid rgb(167, 202, 172);" :src="item.anchor.user.avatar" alt="" />
                </div>
                <div style="margin-top: 10px;margin-left: 15px;">
                  <div style="font-size: 16px;">{{item.anchor.user.name}}</div>
                  <div v-html="filterAnchor(item.anchor.detail)" class="anchor"></div>
                </div>
              </div>
              <div style="font-size: 20px;font-weight: bolder;text-align: left;color: rgb(12, 90, 31);height: auto;width: 90%;word-break:break-all;">
                {{item.name}}
              </div>
              <div class="streaming-time"><img src="@/assets/time.png" alt=""/>直播时间：{{ item.start_at }}</div>
            </div>
          </div>
        </div>
<!--        </div>-->
      </div>
    </div>
    <login-name ref="login"></login-name>
  </div>
</template>

<script>
import {
    getIndexData,
    getStreamingList,
    streamingSubscribe,
} from "@/api/stream";
import moment from "moment";
import LoginName from '@/views/login/index.vue';
import {Message} from "element-ui";

export default {
    name: "",
    components: {LoginName},
    data() {
        return {
            bannerList: [],
            recommendList: [],
            list: [],
            tab: -1,
        };
    },

    computed: {},

    watch: {
        tab: function (val) {
            this.getStreamingList(1);
        },
    },

    created() {
        if (!this.$store.getters.token) {
            Message({message: "暂未登录，请先登录", type: "error", duration: 5 * 1000,});
            // this.$nextTick(()=>{
            //   this.$refs['login'].showlogin()
            // })
        }
        const loading = this.$loading({
            lock: true,
        });
        getIndexData().then((res) => {
            if (res.code == 200) {
                this.bannerList = res.data.carousel.filter((item) => {
                    return item.status == 1;
                });
                this.recommendList = res.data.recommend.map(o => {
                    o.start_at = moment(o.start_at, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm")
                    return o
                }).splice(0, 2);
                console.log(res.data.recommend[0])
            }
            loading.close();
        });
        this.getStreamingList();
    },

    methods: {
        filterAnchor(value) {//获取作者介绍
            return this.$filterHtml.anchor(value);
        },
        goStreaming(id) {
            this.$refs['login'].showlogin()
            this.$router.push('/streaming-page/' + id)
        },
        jumpToMore() {
            this.$router.push("/all-list")
        },
        jumpTo(href) {
            if (!this.$store.getters.token) {
                Message({message: "暂未登录，请先登录", type: "error", duration: 5 * 1000,});
                this.$nextTick(() => {
                    this.$refs['login'].showlogin()
                })
            }
            if (!href) return;
            window.open(href);
        },
        streamingSubscribe(id, item) {
            streamingSubscribe({id}).then((res) => {
                if (res.code == 200) {
                    item.live_fans = 1;
                    this.$message({message: "预约成功", type: "success",});
                }
            });
        },
        getStreamingList() {
            getStreamingList({
                status: this.tab == -1 ? undefined : this.tab,
            }).then((res) => {
                if (res.code == 200) {
                    this.list = res.data.data;
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.container {
  background-image: url("../../assets/background_index.jpg");
}

.scrollbar-flex-content {
  display: flex;
  height: 230px;
  margin: 0 0px;
}

.go {
  cursor: pointer;
  width: 150px;
  height: 100px;
  z-index: 100;
  position: absolute;
  left: 45.5%;
  top: 70%;
}

.container {
  display: flex;
  flex-flow: column;
  //background-color: rgba(255, 255, 255, 0.6);
}

.no-list {
  text-align: center;
  font-size: 18px;
  color: #979da9;
  padding: 200px 0;

  img {
    width: 170px;
    margin-bottom: 30px;
  }
}

.streaming-recommend {
  //padding-bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: center;

  .recommend-title {
    font-size: 20px;
    color: #0C5A1F;
    display: flex;
    flex-flow: row;
    font-weight: 400;
    padding: 15px 0px;
    letter-spacing: 0.05rem;

    .more {
      text-underline: #0C5A1F;
      text-decoration: underline;
      width: 50%;
      text-align: right;
      font-size: 18px;
      cursor: pointer;
    }
  }

  .streaming-wrap {
    background: rgb(239, 255, 238, 0.7);
    //opacity: 0.7;
    border: 2px solid rgb(108, 171, 122);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.2);
    border-radius: 20px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 650px;
    height: 200px;
    cursor: pointer;

    .stream-info {
      width: calc(100% - 300px);

      .streamer-info {
        color: #666666;
        font-size: 14px;

        .streamer-avatar {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-right: 10px;
          overflow: hidden;
          vertical-align: middle;
        }
      }

      .streaming-title {
        font-size: 20px;
        color: #444444;
        font-weight: 600;
        min-height: 50px;
        letter-spacing: 2px;
        margin-top: 20px;
      }

      .streaming-time {
        color: #999999;
        font-size: 14px;
        line-height: 14px;
        padding: 75px 0 0px;
        display: flex;
        align-items: center;

        img {
          width: 14px;
          margin-right: 5px;
        }
      }

      .streaming-watch {
        font-size: 14px;
        color: #666666;

        img {
          width: 18px;
          margin-right: 5px;
        }
      }
    }

    .stream-img {
      width: 300px;
      height: 160px;
      border: 2px solid rgb(108, 171, 122);
      border-radius: 20px;
      //padding-bottom: 5px;
      overflow: hidden;
      margin: 15px;
      background: #ffffff;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
        //border-bottom: 2px solid #a7caac;
        object-fit: cover;
        background: #ffffff;
      }

      .img-tag {
        position: absolute;
        right: 10px;
        bottom: 10px;
        color: #fff;
        background: rgba(0, 0, 0, 0.3);
        font-size: 12px;
        border-radius: 4px;
        padding: 4px 10px;
      }
    }

    .anchor {
      width: 250px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
  }

  .streaming-wrap:nth-child(1) {
    margin-right: 50px;
  }
}

.streaming-time {
  margin-top: 15px;

  img {
    width: 15px;
    vertical-align: middle;
    margin-bottom: 2px;
  }
}

.main-streaming-title {
  height: 117px;
  text-align: center;
  line-height: 117px;
  font-size: 20px;
  color: #040000;
  font-weight: 600;
  background: #f1f1f1;
}

.streaming-container {
  background: #fff;
  overflow: hidden;

  .streaming-nav {
    width: 100%;
    margin: 0 auto;
    border-bottom: 1px solid #e6e6e6;
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;

    .category {
      display: flex;

      .category-wrap {
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;
        height: 46px;
        line-height: 46px;
        border-bottom: 4px solid rgba(0, 0, 0, 0);
        text-align: center;
        width: 35px;
        white-space: nowrap;
        margin-right: 80px;
      }

      .active {
        border-color: #a00145;
      }

      .category-wrap:nth-child(1) {
        margin-right: 40px;
      }
    }

    .more-btn {
      font-size: 14px;
      color: #979daa;
      cursor: pointer;
    }
  }

  .streaming-list {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin: 40px auto;

    .streaming-wrap {
      cursor: pointer;
      background: #fff;
      padding: 30px;
      box-shadow: 0px 0px 18px 0px rgba(92, 35, 59, 0.1);
      border-radius: 6px;
      display: flex;
      align-items: center;
      position: relative;
      width: 700px;
      box-sizing: border-box;
      margin-bottom: 30px;

      .streaming-img {
        width: 290px;
        height: 200px;
        border-radius: 10px;
        overflow: hidden;
        margin-right: 20px;
        background: #dfdfdf;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .streaming-info {
        width: calc(100% - 310px);

        .streaming-title {
          font-size: 20px;
          color: #444444;
          font-weight: 500;
          height: 55px;
          line-height: 30px;
          padding-right: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
        }

        .streaming-time {
          color: #999999;
          font-size: 16px;
          line-height: 16px;
          padding: 80px 0 30px;

          img {
            width: 15px;
            vertical-align: middle;
          }
        }

        .streaming-status {
          font-size: 18px;

          .status-left {
            img {
              width: 21px;
              margin-right: 10px;
            }
          }
        }
      }

      .streaming-btn {
        position: absolute;
        right: 30px;
        bottom: 30px;
        height: 34px;
        width: 100px;
        line-height: 34px;
        font-size: 16px;
        text-align: center;
        color: #a00145;
        border: 1px solid rgba(160, 1, 69, 1);
        border-radius: 6px;
      }

      .is-end {
        .streaming-status {
          color: #666666;
        }
      }

      .not-start {
        .streaming-status {
          color: #01a014;
        }
      }
    }

    .streaming-wrap:nth-child(2n) {
      margin-left: 58px;
    }
  }
}

</style>
